import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PosthogService } from '../services/posthog.service';

export const crmAccessGuard: CanActivateFn = (route, state) => {
  const posthogService = inject(PosthogService);
  const router = inject(Router);

  const hasCRMAccess = posthogService.featureFlagCRM();

  if (!hasCRMAccess) {
    console.warn('[CRM Guard] Access denied - Feature flag not enabled');
    // Redirect to dashboard if no access
    router.navigate(['/dashboard']);
    return false;
  }

  console.log('[CRM Guard] Access granted');
  return true;
};

